import { Input } from "@babackapp/ui/components/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";

export const DEFAULT_PARALLELISM = 10;
export const MAX_PARALLELISM = 50;
export const ALL_ORDERS = "all";
export const DEFAULT_ORDER_WINDOW = "6";

const ORDER_WINDOWS = [
  { value: "3", label: "Commandes : 3 derniers mois" },
  { value: "6", label: "Commandes : 6 derniers mois" },
  { value: "12", label: "Commandes : 12 derniers mois" },
  { value: ALL_ORDERS, label: "Commandes : toutes" },
];

/** Months sent to the API: 0 takes every order. */
export const orderMonthsOf = (orderWindow: string): number =>
  orderWindow === ALL_ORDERS ? 0 : Number(orderWindow);

export function OrderWindowSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-56">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ORDER_WINDOWS.map((window) => (
          <SelectItem key={window.value} value={window.value}>
            {window.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function ParallelismInput({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number) => void;
}) {
  return (
    <>
      <label
        className="text-xs text-muted-foreground"
        title="Documents traités en même temps. Monte progressivement en surveillant Atlas et la latence de l'API."
      >
        Parallélisme
      </label>
      <Input
        type="number"
        min={1}
        max={MAX_PARALLELISM}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        className="w-16 h-8"
      />
    </>
  );
}
